module.exports = __webpack_public_path__ + "img/likesActive.918f1ea9.png";